import { AnyAction } from 'redux';
import { ErrorData } from '@synergy/api';
import { FormikErrors } from 'formik';

import { FormValues } from '../models/form-values';
import {
    PRODUCT_DETAIL_ATTRIBUTE_ERROR,
    PRODUCT_DETAIL_ATTRIBUTE_RECEIVE,
    PRODUCT_DETAIL_ATTRIBUTE_UPDATE,
} from './product-detail-attributes-actions';
import { PRODUCT_DETAIL_RESET } from '../../store/product-detail-actions';
import { ProductAttribute } from '../models/product-attribute';

export interface ProductDetailAttributeReducerState {
    productId: number | null;
    attributes: ProductAttribute[] | null;
    /**
     * The attributes as the server last handed them over (#2159). The list
     * above cannot serve: leaving the tab parks its input right there.
     */
    baseline?: ProductAttribute[] | null;
    requestError?: ErrorData;
    isDirty: boolean;
    isValid: boolean;
    errors: FormikErrors<FormValues>;
}

const initialProductDetailAttributeReducerState: ProductDetailAttributeReducerState = {
    productId: null,
    attributes: null,
    isDirty: false,
    isValid: true,
    errors: {},
};

export const productDetailAttributeReducer = (
    state: ProductDetailAttributeReducerState = initialProductDetailAttributeReducerState,
    action: AnyAction
): ProductDetailAttributeReducerState => {
    switch (action.type) {
        case PRODUCT_DETAIL_RESET: {
            return initialProductDetailAttributeReducerState;
        }

        case PRODUCT_DETAIL_ATTRIBUTE_RECEIVE: {
            return {
                ...state,
                productId: action['attributesList'].id,
                attributes: action['attributesList'].attributes,
                // The same values, kept apart from the ones the tab edits.
                baseline: action['attributesList'].attributes,
                isDirty: false,
            };
        }

        case PRODUCT_DETAIL_ATTRIBUTE_ERROR: {
            return {
                ...state,
                requestError: action['errorData'],
            };
        }

        case PRODUCT_DETAIL_ATTRIBUTE_UPDATE: {
            const { formData, isDirty, isValid, errors } = action;

            const nextAttributes: ProductAttribute[] = (formData.attributes as ProductAttribute[])
                .filter(item => item.attributeId && item.value)
                .map(item => ({ id: item.id, attributeId: item.attributeId, value: item.value }));

            return {
                ...state,
                attributes: nextAttributes,
                isDirty: state.isDirty || isDirty,
                isValid,
                errors,
            };
        }

        default: {
            return state;
        }
    }
};
